import React from 'react';
import { Check } from '@phosphor-icons/react';
import { Badge } from './ui/badge';
import { Card, CardContent } from './ui/card';

export default function ThemeOptionCard({ theme, isSelected, onSelect }) {
  return (
    <Card
      className={`cursor-pointer transition-all hover:shadow-lg ${
        isSelected ? 'ring-2 ring-offset-2' : ''
      }`}
      style={{
        borderColor: isSelected ? theme.colors.primary : 'transparent',
        '--tw-ring-color': theme.colors.primary,
      }}
      onClick={() => onSelect(theme.id)}
      data-testid={`theme-card-${theme.id}`}
    >
      <CardContent className="p-2 sm:p-4">
        <div
          className="h-14 sm:h-20 rounded-md sm:rounded-lg mb-2 sm:mb-3 flex items-center justify-center relative overflow-hidden"
          style={{ background: theme.preview_gradient }}
        >
          {isSelected && (
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
              <Check className="w-6 h-6 sm:w-8 sm:h-8 text-white" weight="bold" />
            </div>
          )}
          <span className="px-1 text-center text-xs sm:text-base text-white font-medium z-10">
            {theme.name}
          </span>
        </div>

        <p className="hidden sm:block text-sm text-muted-foreground mb-3 line-clamp-2">
          {theme.description}
        </p>

        <div className="flex gap-1 mb-0 sm:mb-2">
          {Object.values(theme.colors).slice(0, 4).map((color, index) => (
            <div
              key={`${color}-${index}`}
              className="w-4 h-4 sm:w-6 sm:h-6 rounded-full border border-gray-200"
              style={{ backgroundColor: color }}
              title={color}
            />
          ))}
        </div>

        <Badge variant="outline" className="hidden sm:inline-flex text-xs capitalize">
          {theme.mood}
        </Badge>

        <div className="hidden md:block mt-2 text-xs text-muted-foreground">
          Pattern: {theme.decorations?.pattern} | Style: {theme.decorations?.border_style}
        </div>
      </CardContent>
    </Card>
  );
}
